import React from 'react';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { Building2, UserRound, Users, CircleCheck, CircleX, Store } from 'lucide-react';
import { PageHeader, StatusTag } from '../../../common';

const { RangePicker } = DatePicker;

/** One labeled block of the team strip (Gerente / Asesores). */
const TeamItem = ({ icon, label, children }) => (
    <div className="flex items-start gap-3 min-w-0">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-surface-100 text-[15px] text-surface-600">{icon}</span>
        <div className="min-w-0 flex-1">
            <div className="mb-1 text-xs font-medium text-surface-500">{label}</div>
            {children}
        </div>
    </div>
);

function ClientTitle({ client, gerente, asesores, getStoresChecksByClientId, setLoading }) {
    const today = dayjs();
    const asesorNames = asesores?.filter((asesor) => asesor && asesor.name).map((asesor) => asesor.name) || [];

    return (
        <div>
            <PageHeader
                icon={<Building2 />}
                title={client?.name}
                description={<span className="tabular-nums">RIF: {client?.rif}</span>}
                meta={
                    <>
                        <StatusTag tone={client?.active ? 'success' : 'danger'} icon={client?.active ? <CircleCheck /> : <CircleX />}>
                            {client?.active ? 'Activo' : 'Inactivo'}
                        </StatusTag>
                        <StatusTag tone={client?.channel === 'moderno' ? 'info' : 'warning'} icon={<Store />}>
                            {client?.channel === 'moderno' ? 'Moderno' : 'Tradicional'}
                        </StatusTag>
                    </>
                }
                actions={
                    <label className="flex flex-col gap-1">
                        <span className="text-xs font-medium text-surface-500">Período de análisis</span>
                        <RangePicker
                            maxDate={today}
                            onChange={(e) => {
                                if (e && e[0] && e[1]) {
                                    setLoading(true);
                                    getStoresChecksByClientId(e[0].format('YYYY-MM-DD'), e[1].format('YYYY-MM-DD'));
                                }
                            }}
                            defaultValue={[today.startOf('month'), today.endOf('month')]}
                        />
                    </label>
                }
                className="!mb-4"
            />

            {/* Team */}
            <div className="shelf-card grid gap-4 p-5 md:grid-cols-2">
                <TeamItem icon={<UserRound />} label="Gerente Responsable">
                    <div className="truncate text-sm font-semibold text-surface-900">{gerente?.name || 'Sin asignar'}</div>
                </TeamItem>
                <TeamItem icon={<Users />} label="Asesores Asignados">
                    {asesorNames.length > 0 ? (
                        <div className="flex flex-wrap gap-1.5">
                            {asesorNames.map((name, idx) => (
                                <StatusTag key={idx} tone="brand">
                                    {name}
                                </StatusTag>
                            ))}
                        </div>
                    ) : (
                        <span className="text-sm text-surface-400">Sin asignar</span>
                    )}
                </TeamItem>
            </div>
        </div>
    );
}

export default ClientTitle;
